import React, { Component } from "react";
import "primereact/resources/themes/nova-light/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import UserService from "../../services/UserService";
import DispatchService from "../../services/DispatchService";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import tableRequest from "../../models/tableRequest.js";
import { confirmAlert } from "react-confirm-alert"; // Import
import { ConfirmationModal } from "../../template/ConfirmationModal";
import MessageComponent from "../../template/Message";
import $ from "jquery";
import PrintDispatchService from "../../services/PrintDispatchService";
import ApiService from "../../services/apiService";
import WareHouseMaterService from '../../services/WareHouseMaterService';
import Loaders from '../../template/Loaders';
export default class Dispatch extends Component {
  constructor(props) {
    super(props);
    this.UserService = new UserService();
    this.DispatchService = new DispatchService();
    this.PrintDispatchService = new PrintDispatchService();
    this.ApiService = new ApiService();
    this.WareHouseMaterService = new WareHouseMaterService();
    this.tblResponse = new tableRequest();
    this.state = {
      scanTxt: '',
      warehouseVisible: true,
      visible: false,
      dialogVisible: false,
      showModal: false,
      selectedBatch: '',
      selectedDeliveryId: null,
      cartoonLoader: false,
      DeliveryId: null,
      scanItemLoader: true,
      remarkVisible: false,
      eventBlock: false,
      sortIcon: false,
      sortOrder: "1",
      Batch: '', 
      DeliveryNo: '', 
      selectedDeliveryDetailId: '',
      formError: {},
      UserDDL: [],
      SelectedDDL: [],
      wareHouseDDL: [],
      WareHouseFactoryDDL: [],
      SendTo: [],
      SONumber: '',
      buttonLabel: "Submit",
      DeliveryId: null,
      DeliveryDetailId: null,
      DeliveryOptions: [],
      batchData: [],
      BatchId: null,         // State for selected batch
      BatchOptions: [],
      sales: [],
      batchDetailsByDeliveryId: [],
      scanItems: [],
      loading: true,
      first: 0,
      rows: 5,
      totalRecords: 0,
      globalFilter: null,
      emptyMessage: "No Data found",
      emptyMessage1: "No Previous Scanned Data found !!",
      bill_Address1: "",
      bill_Address2: "",
      bill_City: "",
      bill_Country: "",
      ship_to_Party: "",
      ship_to_Party_Name: "",
      bill_Pincode: "",
      bill_State: "",
      ship_Address1: "",
      ship_Address2: "",
      ship_City: "",
      ship_Country: "",
      ship_Pincode: "",
      ship_State: "",
      IsOldProduct: false,
      Remark: "",
      globalFilter: null,
      needtoSaveDispatch: ""
    };
    this.hideFunc = this.hideFunc.bind(this);
    this.actionTemplate = this.actionTemplate.bind(this);
    this.actionTemplate1 = this.actionTemplate1.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleScanChange = this.handleScanChange.bind(this);
    this.handleBatchChange = this.handleBatchChange.bind(this);
    this.ScanItem = this.ScanItem.bind(this);
    this.setCartonDetails = this.setCartonDetails.bind(this);
    //this.sendToEvent = this.sendToEvent.bind(this);
    this.submitForm = this.submitForm.bind(this);
    this.submitRemark = this.submitRemark.bind(this);
    this.onPage = this.onPage.bind(this);
    this.searchFilter = this.searchFilter.bind(this);
    this.onSort = this.onSort.bind(this);
    this.ScanItem = this.ScanItem.bind(this);
    this.onValueChange = this.onValueChange.bind(this);
  }
  //trigger api function on page call
  componentDidMount() {

    const isAdmin = sessionStorage.getItem("IsAdmin") === 'true';
    this.setState({ isAdmin });
    console.log('isAdmin:', isAdmin);
    setTimeout(() => {
      this.GetDispatch();
      this.GetWareHouse();
      const objtoprint = {
        CartonId: "DID-2020-21-00001",
        CreatedDt: "14/07/20",
        Qty: "2",
        userDetail: {
          UserId: 30,
          Token: null,
          RefreshToken: null,
          ReferenceID: "CE1215F5-44DE-46F0-B9B7-72E1D1B24172",
          Username: "ajaytestdealer",
          Password: null,
          FirstName: "new",
          LastName: "gupta",
          Email: null,
          MobileNo: "8181818181",
          UserType: 2,
          ProfileImage: null,
          DeviceType: null,
          IsActive: true,
          InActiveReason: null,
          CreatedBy: null,
          CreatedDt: "2020-07-10T13:57:11.46",
          UpdatedBy: null,
          UpdatedDt: null,
          Salt: null,
          CreatedDate: null,
          IsResetPassword: false,
          TotalRows: 0,
          userId: 0,
          Id: 0,
          ship_Country: "101",
          ship_State: "1",
          ship_City: "93",
          ship_CountryName: "India",
          ship_StateName: "Andaman & Nicobar Islands",
          ship_CityName: "Carnicobar",
          ship_Address1: "Add1",
          ship_Address2: "Add2",
          ship_Pincode: "1902929",
          bill_Country: "101",
          bill_State: "4",
          bill_City: "91",
          bill_CountryName: "India",
          bill_StateName: "Assam",
          bill_CityName: "Cachar",
          bill_Address1: "Add1",
          bill_Address2: "Add2",
          bill_Pincode: "1902929",
        },
        cartonList: [
          {
            ProductName: "KROSIN-AG",
            CartonId: "TID-2020-21-00001",
            TotalQty: null,
            CartonId: null,
            TotalQty: "2",
            ProductUOM: "Pieces",
          },
          {
            ProductName: "Keetnashak",
            CartonId: "TID-2020-21-00002",
            TotalQty: null,
            CartonId: null,
            TotalQty: "3",
            ProductUOM: "Pieces",
          },
        ],
      };


      //this.PrintDispatchService.Printpdf(objtoprint);
    }, 1000);

    $(".p-column-title").on("click", function () {
      $(this)
        .next()
        .removeClass("pi-sort")
        .toggleClass("pi-sort-up")
        .addClass("pi-sort-down");
    });

    this.GetActiveUsers();
    //if user type is 1 state of visible will be set to true
    if (this.ApiService.getUserType() == 1) {
      this.setState({
        visible: true,
      });
    }
  }

  // PAGE EVENT CALL
  onPage(event) {
    this.setState({
      loading: true,
    });

    //imitate delay of a backend call
    setTimeout(() => {
      debugger;

      this.getLazyLoadingValues(event);
      this.GetDispatch();
    }, 250);
  }
  fetchData  () {
    debugger
   // const  DeliveryId  = this.state.DeliveryId
    this.setState({  dialogVisible: true })
    // if (DeliveryId) {
    
       
    //     this.DispatchService.GetDeliveryStatus(DeliveryId)
    //     .then(data => {
    //       const resdata = data.data; 
    //       debugger// Extract data from the response
    //       this.setState({ apiData: resdata, dialogVisible: true }); // Update state and show dialog
    //     })
    //     .catch(error => {
    //       console.error('Error fetching data:', error);
    //       // Optionally set an error message in the state
    //       this.setState({ formError: { Fetch: 'Failed to fetch delivery status.' } });
    //     });
    // } else {
    //   this.setState({ formError: { SendTo: 'Please select a delivery.' } });
    // }
  };
  hideFunc() {
    this.setState({
      remarkVisible: false,
      visible: false
      // formHeading: 'Add User'
    })

  }
  // set lazy loading values
  getLazyLoadingValues(event) {
    this.setState({ rows: event.rows });
    this.tblResponse.PageSize = event.rows;
    this.tblResponse.First = event.first + 1;
    this.tblResponse.IsActive = true;
    this.tblResponse.SearchValue = event.globalFilter ? event.globalFilter : "";
    //this.tblResponse.SortColumn = event.sortField;
    this.tblResponse.SortOrder = event.sortOrder === 1 ? "ASC" : "DESC";
  }

  // get users data list from api
  GetDispatch() {
    debugger;
    this.setState({ cartoonLoader: false });
    this.tblResponse.SortColumn = 'CreatedDt';
    this.DispatchService.GetDispatch(this.tblResponse).then((data) => {
      const resdata = data.data;
      this.setState({ cartoonLoader: true });
      debugger
      //if ResponseData is not null sales state will be set with ResponseData
      if (
        resdata !== null &&
        resdata.ResponseData !== null &&
        resdata.ResponseData.length > 0
      ) {
        this.datasource = resdata.ResponseData;
        this.setState({
          totalRecords: resdata.ResponseData[0].TotalRows,
          first: (this.tblResponse.First - 1),
          sales: this.datasource.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
          loading: false,
        });
      }
      //if ResponseData is  null sales state will be set null
      else {
        this.datasource = null;
        this.setState({
          totalRecords: 0,
          first: 1,
          sales: null,
          loading: false,
        });
      }
    });
  }

  // call every change of form and validation part also
  handleChange = (e) => {
    debugger
    const selectedDeliveryId = e.value;
    const selectedDelivery = this.state.DeliveryOptions.find(option => option.value === e.value);
    this.setState({
      DeliveryId: selectedDeliveryId,
      DeliveryNo: selectedDelivery.label,
      shipToParty: selectedDelivery.ship_to_Party,
      shipToPartyName: selectedDelivery.ship_to_Party_Name,
      plant: selectedDelivery.plant,
      billType: selectedDelivery.billType
    });
    this.GetBatchDDL(selectedDeliveryId);
    this.GetTempDataForDispatch(selectedDeliveryId);
  }
  handleScanChange(e) {
    this.setState({ scanTxt: e.target.value });
  }
  // validate form
  validateForm(value, name) {
    let errors = this.state.formError;
    let IsValid = true;
    //to validate each form field with required conditions
    switch (name) {
      case "UserName":
        if (value.length < 1) {
          IsValid = false;
          errors.UserName = "Please enter your username.";
        } else errors.UserName = "";
        break;
      case "SendTo":
        console.log(value);
        this.state.bill_Address1 = value.bill_Address1;
        this.state.bill_Address2 = value.bill_Address2;
        this.state.bill_Pincode = value.bill_Pincode;
        this.state.bill_Country = value.bill_CountryName;
        this.state.bill_State = value.bill_StateName;
        this.state.bill_City = value.bill_CityName;
        this.state.ship_Address1 = value.ship_Address1;
        this.state.ship_Address2 = value.ship_Address2;
        this.state.ship_Pincode = value.ship_Pincode;
        this.state.ship_Country = value.ship_CountryName;
        this.state.ship_State = value.ship_StateName;
        this.state.ship_City = value.ship_CityName;
        this.setState({
          eventBlock: true,
        });
        break;
      default:
        break;
    }
    return IsValid;
  }

  // reset form text value
  formReset() {
    this.setState({
      ReferenceID: "",
      UserName: "",
      FirstName: "",
      LastName: "",
      Email: "",
      MobileNo: "",
      Password: "",
      ConfirmPassword: "",
      IsActive: true,
    });
    let errors = this.state.formError;
    Object.entries(errors).map(([key, value]) => {
      errors[key] = "";
    });
  }

  // open Dialog
  openDialog() {
    this.setState({
      visible: true,
    });
    this.formReset();
  }

  // submit packing
  submitForm(event) {
    debugger
    event.preventDefault();

    if (this.state.scanItems.length == 0) {
      this.refs.Messchild.showWarn("Scan First");
      return;
    }

    else if (this.state.TotalCaseCount !== this.state.TotalData) {
      this.refs.Messchild.showWarn("OBD is not completely scanned !!");
      return;
    }
    //if(this.state.CartonId.ca)
    else {



      let formData = {};


      formData = {

        //Qty:this.state.TotalCaseCount,
        TotalQty: this.state.TotalData,
        DeliveryNo: this.state.DeliveryNo,
      };


      this.SaveDispatch(formData);

    }


  }


  submitRemark(event) {
    event.preventDefault();
    let formD = { ...this.state.needtoSaveDispatch };
    formD.Remark = this.state.Remark;
    this.SaveDispatch(formD);
  }


  SaveDispatch(formData) {
    debugger
    this.setState({ scanItemLoader: false });
    const { DeliveryNo } = this.state; // or from props if applicable

    // Add DeliveryNo to formData
    const updatedFormData = {
      ...formData,
      DeliveryNo: DeliveryNo // Add DeliveryNo to formData
    };
    setTimeout(() => {
      this.DispatchService.Save(updatedFormData).then((data) => {
        this.setState({ scanItemLoader: true });
        const resdata = data.data;
        //if ResponseCode is 200 success message will be shown else will move to 'else statement'
        if (resdata !== null && resdata.ResponseCode === "200") {
          this.refs.Messchild.showSuccess(resdata.ResponseMessage);
          //this.PrintDispatchService.Printpdf(resdata.ResponseData);
          this.state.scanItems = [];
          this.setState({
            scanItems: [],
            SendTo: [],
            remarkVisible: false,
            needtoSaveDispatch: ""
          });
          this.GetDispatch();
          this.GetWareHouse();
        } else if (resdata.ResponseCode === "400") {
          this.refs.Messchild.showWarn(resdata.ResponseMessage);
        } else {
          this.refs.Messchild.showError(resdata.ResponseMessage);
        }
      });
    }, 1000);

  }
  closeDialog = () => {
    this.setState({ dialogVisible: false, apiData: [] }); // Hide the dialog and reset apiData
  };
  handleBatchChange = (e) => {
    debugger
    this.setState({ Batch: e.target.value });
  }

  actionTemplate1 = (rowData) => {
    debugger
    return (
      <Button type="button" onClick={() => this.openModal(rowData)} icon="pi pi-pencil" className="p-button-warning" >
      </Button>
    );
  }

  openModal = (rowData) => {
    debugger;
    this.setState({
      visible: true,
      buttonLabel: 'Update',
      formHeading: 'Update User',
      Batch: rowData.Batch, // Set Batch to the selected batch
      selectedDeliveryDetailId: rowData.DeliveryId // Assuming you have a DeliveryId in your rowData
    });
  }

  // get active carton drop down list
  GetActiveUsers() {
    debugger;
    this.UserService.GetAllActiveUsers().then((data) => {
      const resdata = data.data;
      //if ResponseCode is 200 UserDDL state will be set to ResponseData
      if (resdata !== null && resdata.ResponseCode === "200") {
        this.setState({
          UserDDL: resdata.ResponseData,
        });
      }
    });
  }

  // scan qr code
  ScanItem(e) {
    debugger
    if (e.key === 'Enter') {
      let qr = e.target.value;
      console.log(this.state.SendTo);
      var soNumber = this.state.SONumber;

      if (this.state.DeliveryId.length == 0) {

        this.refs.Messchild.showWarn("Select Delivery No.");
        return;
      }

      if (qr.includes("SID") || qr.includes("di-details") || qr.length === 18) {
        debugger
        this.setCartonDetails(qr, true, soNumber);
      } else {
        this.refs.Messchild.showWarn("Invalid Scanned");
      }
      this.setState({
        scanTxt: ""
      });

    }
  }



  setCartonDetails(qr) {
    debugger
    this.DispatchService.GetTertiaryPackingScan(qr).then((data) => {
      debugger
      const resdata = data.data;
      if (resdata && resdata.ResponseCode === "200") {
        const res = resdata.ResponseData[0];
        this.setState({
          scanTxt: "",
        });

        const { scanItems, batchDetailsByDeliveryId, plant, batchStorageLocations } = this.state;

        // Log incoming scanned data
        console.log("Scanned Data:", res);
        console.log("Current Scan Items:", scanItems);
        console.log("Batch Details By Delivery ID:", batchDetailsByDeliveryId);

        if (scanItems.some(item => item.CartonId === res.CartonId)) {
          this.refs.Messchild.showWarn("Already Scanned");
          return;
        }

        // Log the batch and material code matching
        const matchingDetail = batchDetailsByDeliveryId.find(detail =>
          detail.MaterialCode === res.MaterialCode
        );

        console.log("Matching Detail:", matchingDetail);

        const validPlant = res.Plant === plant;
        const validStorageLocation = batchStorageLocations.includes(res.StorageLocation);

        if (matchingDetail && validPlant ) {

          const updatedBatchDetails = batchDetailsByDeliveryId.map(detail => {
            if (   detail.MaterialCode === res.MaterialCode) {
              return {
                ...detail,
                Cases: Math.max(detail.Cases - 1, 0) // Ensure Cases does not go below zero
              };
            }
            return detail;
          });

          // Debug: Check updatedBatchDetails
          console.log("Updated batchDetailsByDeliveryId:", updatedBatchDetails);

          // Update state
          this.setState({
            batchDetailsByDeliveryId: updatedBatchDetails,
            scanTxt: "",
            SONumber: ""
          });

          const payload = {
            dispatchSaveList: [{
              deliveryId: this.state.DeliveryId || 0,
              createdBy: 0,
              deliveryNo: this.state.DeliveryNo || "",
              sid: res.CartonId || "",
              scanId: res.Id,
              productCode: res.MaterialCode || "",
              productName: res.ProductName || "",
              batchNo: res.BatchNumber || "",
              totalQty: res.TotalQty || 0,
              storageLocation: res.StorageLocation || "",
            }]
          };

          this.DispatchService.SaveDispatchCartonintoTemp(payload).then(response => {
            const responseData = response.data;
            if (responseData && responseData.ResponseCode === "200") {
              this.GetTempDataForDispatch(this.state.DeliveryId);
              console.log("SaveDispatchCartonintoTemp success:", responseData);
            } else {
              this.refs.Messchild.showWarn(responseData.ResponseMessage || "Failed to save dispatch carton.");
            }
          }).catch(error => {
            console.error("API call failed:", error);
            this.refs.Messchild.showWarn("Error occurred while saving dispatch carton.");
          });

        } else if (!validPlant) {
          this.refs.Messchild.showWarn("Invalid Plant");
        }  else {
          this.refs.Messchild.showWarn("Invalid Material Code");
        }
      } else if (resdata && resdata.ResponseCode === "500") {
        this.setCartonDetails(qr, false);
      } else {
        this.refs.Messchild.showWarn(resdata.ResponseMessage);
      }
    });
  }


  deleteScanned(CartonId) {
    let arrayfilter = this.state.scanItems.filter(
      (x) => x.CartonId != CartonId
    );

    this.setState({
      scanItems: arrayfilter,
    });
  }

  GetWareHouse() {
    this.DispatchService.DeliveryDDL().then(data => {
      const resdata = data.data;
      if (resdata && resdata.ResponseData && resdata.ResponseData.length > 0) {

        const deliveries = resdata.ResponseData;
        const deliveryOptions = deliveries.map(delivery => ({
          label: delivery.DeliveryNo,
          value: delivery.DeliveryId,
          ship_to_Party: delivery.ShipToParty,
          ship_to_Party_Name: delivery.ShipToPartyName,
          plant: delivery.Plant,
          billType: delivery.BillType
        }));

        this.setState({
          DeliveryOptions: deliveryOptions,

        });
      }
    });
  }
  GetTempDataForDispatch(selectedDeliveryId) {
    debugger
    // this.setState({ scanItemLoader: true }); // Show loader

    this.DispatchService.GetTempDataForDispatch(selectedDeliveryId).then(data => {
      debugger
      const resdata = data.data;

      if (resdata && resdata.ResponseCode === "200") {
        // Assuming ResponseData contains the array of scan items
        this.setState({
          scanItems: resdata.ResponseData || [],
          emptyMessage1: resdata.ResponseData && resdata.ResponseData.length === 0 ? "No data available" : "",
          //scanItemLoader: false // Hide loader
          TotalData: resdata.ResponseData.length
        });
      } else {
        // Handle response errors
        this.setState({
          emptyMessage: resdata.ResponseMessage || "Failed to load data",
          // scanItemLoader: false // Hide loader
        });
        this.refs.Messchild.showWarn(resdata.ResponseMessage || "Failed to load data");
      }
    }).catch(error => {
      // Handle network or other errors
      console.error("API call failed:", error);
      this.setState({
        emptyMessage: "Error occurred while fetching data",
        scanItemLoader: false // Hide loader
      });
      this.refs.Messchild.showWarn("Error occurred while fetching data");
    });
  }

  GetBatchDDL(selectedDeliveryId) {
    debugger
    this.DispatchService.GetBatchDDL(selectedDeliveryId).then(data => {
      debugger
      const resdata = data.data;
      if (resdata && resdata.ResponseData && resdata.ResponseData.length > 0) {
        const batchDetails = resdata.ResponseData; // Directly using ResponseData

        const totalCases = batchDetails.reduce((sum, detail) => sum + (detail.Cases || 0), 0);

        // Add total cases to the state or log it
        console.log("Total Cases:", totalCases);
        this.setState({

          TotalCaseCount: totalCases

        });

        const batchDetailsWithTotalCases = batchDetails.map(detail => ({
          ...detail,
          TotalCases: detail.Cases,

        }));

        this.batchDetailsByDeliveryId = batchDetailsWithTotalCases;
        this.setState({
          BatchDetails: batchDetailsWithTotalCases,
          BatchOptions: batchDetailsWithTotalCases.map(detail => ({
            label: detail.Batch,
            value: detail.Id,
            TotalCases: detail.Cases,

            // Replace or calculate as needed
          })),
          batchStorageLocations: batchDetails.map(b => b.StorageLocation)
        });
        this.setState({
          // totalRecords: resdata.batchDetailsByDeliveryId[0].TotalRows,
          first: (this.tblResponse.First - 1),
          batchDetailsByDeliveryId: this.batchDetailsByDeliveryId.slice(0, ((this.tblResponse.First - 1) + this.tblResponse.PageSize)),
          loading: false,
        });

      }
    });
  }
  handleUpdateButtonClick = () => {
    debugger
    const { Batch, selectedDeliveryDetailId } = this.state; 
    const formData = { batchNo: Batch, 
      deliveryDetailsId: selectedDeliveryDetailId };
    this.SaveDispatch(formData);
  };
  render() {
    return (
      <>
        {/* Other component JSX */}
        <Dialog
          header="Details"
          visible={this.state.dialogVisible}
          onHide={this.closeDialog}
          style={{ width: '80vw' }} // Adjust width as needed
        >
          <DataTable value={this.state.apiData} paginator rows={10} className="datatable">
            <Column field="field1" header="Field 1" />
            <Column field="field2" header="Field 2" />
            <Column field="field3" header="Field 3" />
            {/* Add more columns as needed */}
          </DataTable>
          <Button label="Close" onClick={this.closeDialog} />
        </Dialog>
      </>
    );
  }

  SaveDispatch(formData) {
    debugger
    const { Batch, selectedDeliveryDetailId } = this.state; 
    const formData1 = { batchNo: Batch, 
      deliveryDetailsId: selectedDeliveryDetailId };
      setTimeout(() => {
        this.DispatchService.UpdateBatchNo(FormData).then((data) => {
          const resdata = data;
    
          // Check the ResponseCode and show the appropriate message
          if (resdata.ResponseCode === "200") {
            this.refs.Messchild.showSuccess(resdata.ResponseMessage);
          } else if (resdata.ResponseCode === "201") {
            this.refs.Messchild.showWarn(resdata.ResponseMessage); // Handle the specific error case
          } else {
            this.refs.Messchild.showWarn("An unexpected error occurred."); // Handle unexpected cases
          }
        }).catch((error) => {
          console.error('Error updating batch:', error);
          this.refs.Messchild.showWarn("Failed to update batch. Please try again."); // Show error message on catch
        });
      }, 10);
    }

  GetStorageDDL(DeliveryDetailId) {
    this.DispatchService.GetStorageDDL(DeliveryDetailId).then(data => {
      debugger
      const resdata = data.data;
      if (resdata && resdata.ResponseData && resdata.ResponseData.length > 0) {
        const batchn = resdata.ResponseData[0];
        const batchOptions = batchn.map(batch => ({
          label: batch.Batch, // Assuming you have BatchNo or similar
          value: batch.Id  // Assuming you have BatchId or similar
        }));

        this.setState({
          BatchOptions: batchOptions
        });
      }
    });
  }

  // seach table
  searchFilter(e) {
    this.setState({
      loading: true,
    });
    this.tblResponse.SearchValue = e.target.value;
    this.GetDispatch();
  }

  callbackFunction = (childData) => {
    this.setState({ message: childData });
  };

  onValueChange(event) {
    debugger
    const val = event.target.value;

    if (val == "Dealer") {
      const Dealer = this.state.UserDDL.filter((x) => x.UserType == 2);
      this.setState({
        SelectedDDL: Dealer,
        warehouseVisible: true,
      });
    }
    if (val == "Distributor") {
      const Distributor = this.state.UserDDL.filter((x) => x.UserType == 1);

      this.setState({
        SelectedDDL: Distributor,
        warehouseVisible: true,
      });
    }
    if (val == "WareHouse") {
      debugger
      const wareHouse = this.state.WareHouseFactoryDDL.filter((x) => x.IsFactory == 0 && x.IsDepot == 0);
      this.setState({
        wareHouseDDL: wareHouse,
      });

      this.setState({
        warehouseVisible: false,
      });
    }

    if (val == "Factory") {
      const fact = this.state.WareHouseFactoryDDL.filter((x) => x.IsFactory == 1);
      this.setState({
        wareHouseDDL: fact,
        warehouseVisible: false,
      });
    }
    if (val == "Depot") {
      const Depot = this.state.WareHouseFactoryDDL.filter((x) => x.IsDepot == 1);
      this.setState({
        wareHouseDDL: Depot,
        warehouseVisible: false,
      });
    }
  }

  // disabled checkbox
  activeTemplate(rowData, column) {
    return <input type="checkbox" disabled checked={rowData.IsActive} />;
  }

  // Sort table
  onSort(event) {

    this.setState({ sortOrder: this.state.sortOrder === 1 ? 2 : 1 });
    const sortField = event.sortField == "CreatedDt" ? "CreatedDt" : event.sortField;
    this.tblResponse.SortOrder = this.state.sortOrder === 1 ? "DESC" : "ASC";
    this.GetDispatch();
    const clickData = document.getElementsByClassName(
      "p-sortable-column-icon pi pi-fw pi-sort"
    );
    console.log(event);
  }
  RemoveDataFromTempScannedRecords(id) {
    debugger;

    this.DispatchService.RemoveDataFromTempScannedRecords(id).then(
      (data) => {
        debugger;
        const resdata = data.data;
        if (resdata.ResponseCode == 200) {
          let arrayfilter = this.state.scanItems.filter((x) => x.Id != id);
          this.GetTempDataForDispatch(this.state.DeliveryId);
          this.setState({
            scanItems: arrayfilter,
            totalScans: this.state.totalScans - 1,
          });
          this.state.allscanItems = this.state.scanItems;
        } else {
          this.refs.Messchild.showSuccess(resdata.ResponseMessage);
          setTimeout(() => {
            window.location.reload();
          }, 1000);
          return;
        }
      }
    );
  }
  // edit form
  actionTemplate(rowData, column) {
    debugger
    const deleteFunc = () => {
      confirmAlert({
        title: "Confirm to delete",
        message: "Are you sure to do this.",
        buttons: [
          {
            label: "Yes",
            onClick: () => this.RemoveDataFromTempScannedRecords(rowData.Id),
          },
          {
            label: "No",
            onClick: () => null,
          },
        ],
      });
    };

    return (
      <span>
        <Button type="button" icon="pi pi-trash" onClick={deleteFunc} className="p-button-danger"></Button>
      </span>
    );
  }

  // create html part
  render() {
    let header = (
      <div className="row">
        <div className="col-md-8 text-left"></div>
      
      </div>
    );

    let header2 = (
      <div className="row">
        <div className="col-md-4 text-left">
          <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
          <InputText type="search" onInput={this.searchFilter} placeholder="Global Search" size="30" />
        </div>
      </div>
    );


    return (
      <>
        <MessageComponent ref="Messchild" />
        <ConfirmationModal parentCallback={this.callbackFunction} ref="child" />
        <div className="heading">
          <h1>Dispatch</h1>
          {/* <Button label="Add Packing" icon="pi pi-plus-circle" onClick={this.openDialog} /> */}
        </div>
        <div className="w-100 px-4 row">
          <form className="form-inline dispatch-label row mb-3">

            <div className="form-group col-md-4">
              <label className="ml-2 mr-2">Delivery No:</label>
              <div className="custom-drop">
                <Dropdown
                  optionLabel="label"
                  onChange={this.handleChange}
                  value={this.state.DeliveryId}
                  className="form-control"
                  placeholder="Select Delivery"
                  name="SendTo"
                  options={this.state.DeliveryOptions}
                />
                {this.state.formError.SendTo !== null ? (
                  <div className="error">{this.state.formError.SendTo}</div>
                ) : null}
              </div>




            </div>

            <div className="form-group col-md-4">
              <label className="ml-2 mr-2">Scan items:</label>
              <input onChange={e => { this.handleScanChange(e) }} name="scanTxt" value={this.state.scanTxt} type="search"
                className="form-control ml-2" id="scanTxt" onKeyDown={e => { this.ScanItem(e) }} />


            </div>

            {/* <Button
                label="Show Details"
                onClick={this.fetchData}
                className="ml-2"
              /> */}

          </form>
        </div>
      
        <div>
          <div className="address-block" >


            <h4 className="mt-3">Shipping address</h4>
            <div className="row dispatch-label mb-3">
              <div className="col-md-3">
                <label><strong>Ship To Party: &nbsp;</strong></label>

                {this.state.shipToParty}
              </div>
              <div className="col-md-3">
                <label><strong>Ship To Party Name: &nbsp;</strong></label>

                {this.state.shipToPartyName}
              </div>
              <div className="col-md-3">
                <label><strong>Plant: &nbsp;</strong></label>

                {this.state.plant}
              </div>
              <div className="col-md-3">
                <label><strong>Bill Type: &nbsp;</strong></label>

                {this.state.billType}
              </div>
              {/* <div className="col-md-3">
                <label><strong>Address 1 : </strong></label>

                {this.state.ship_Address1}
              </div>
              <div className="col-md-3">
                <label><strong>Address 2 : </strong></label>

                {this.state.ship_Address2}
              </div> */}
              {/* <div className="col-md-3">
                <label><strong>PinCode : </strong></label>

                {this.state.ship_Pincode}
              </div>
              <div className="col-md-3">
                <label><strong>City : </strong></label>

                {this.state.ship_City}
              </div>
              <div className="col-md-3">
                <label><strong>State : </strong></label>

                {this.state.ship_State}
              </div>
              <div className="col-md-3">
                <label><strong>Country : </strong></label>

                {this.state.ship_Country}
              </div> */}
            </div>
          </div>
          
          <div className="pb-4">
            <Loaders loader={this.state.cartoonLoader} classType="small" />
            <DataTable responsive={true}

              emptyMessage={this.state.emptyMessage}
              value={this.state.batchDetailsByDeliveryId} // Ensure this is the state key being updated
              sortMode="multiple"
              paginator={false}
              rows={50}
              rowsPerPageOptions={[5, 10, 20]}
              totalRecords={this.state.totalRecords}
              lazy={true}
              first={this.state.first}
              onPage={this.onPage}
              onSort={this.onSort}
              className="tblAuto customertablebg" >

              <Column field="LineItem" header="LineItem" />
              <Column field="StorageLocation" header="Storage Location" />
              <Column field="MaterialCode" header="Material Code" />
              <Column field="MaterialDescription" header="Material Description" />
              {/* <Column field="SAPBatch" header="SAP Batch" /> */}
              <Column field="Batch" header="Batch" />
              <Column field="Qty" header="Qty" />
              <Column field="TotalCases" header="Case" />
              {/* <Column body={this.actionTemplate1} header="Update Batch" /> */}
            </DataTable>

          </div>

        </div>

        <Loaders loader={this.state.scanItemLoader} />
        <DataTable
          responsive={true}
          header={header}
          emptyMessage={this.state.emptyMessage}
          value={this.state.scanItems}
          sortMode="multiple"
          paginator={false}
          rows={1000}
          className="tblAuto"
        >
          <Column field="SID" header="Carton Id" sortable={true} />
          <Column field="ProductName" header="Product Name" sortable={true} />
          <Column field="BatchNo" header="Batch No" sortable={true} />
          <Column field="TotalQty" header="Carton Qty" sortable={true} />
          <Column field="ScannedDate" header="Scanned Date" sortable={true} />
          {this.state.isAdmin && (
            <Column body={this.actionTemplate} header="Action" />
          )}
        </DataTable>

        <div className="container mt-4 mb-4">
          {this.state.isAdmin && (
            <div className="col-md-12 text-center">
              <button className="btn btn-primary mt-4" onClick={this.submitForm}>
                Submit
              </button>
            </div>
          )}
        </div>

        <div className="col-md-12">
          <Loaders loader={this.state.cartoonLoader} classType="small" />
          <DataTable responsive={true} header={header2} globalFilter={this.state.globalFilter}
            emptyMessage={this.state.emptyMessage} value={this.state.sales} sortMode="multiple" paginator={true}
            rows={this.state.rows} rowsPerPageOptions={[5, 10, 20]} totalRecords={this.state.totalRecords} lazy={true}
            first={this.state.first} onPage={this.onPage} onSort={this.onSort}

            className="tblAuto">
            <Column field="DispatchId" header="Dispatch Id" sortable={true} />
            <Column field="ProductName" header="Product Name" sortable={true} />
            {/* <Column field="ProductDscrptn" header="Product Description" sortable={true} /> */}
            <Column field="BatchNumber" header="Batch Number" sortable={true} />
            <Column field="InvoiceNumber" header="Delivery Number" sortable={true} />
            <Column field="TotalTertiaryCarton" header="Total Carton" sortable={true} />

            <Column field="CreatedDt" header="Created Date" sortable={true} />
            {/* <Column field="userName" header="Sent" sortable={true} /> */}
          </DataTable>
        </div>

        <Dialog className="popup-modal" style={{ width: '30%' }} header="Add approval remarks"
          visible={this.state.remarkVisible} modal={true} onHide={this.hideFunc}>
          <form onSubmit={this.submitRemark}>
            <div className="row">
              <div className="col-md-12">
                <label>Remark<span>*</span>:</label>
                <input type="text" style={{ width: '100%' }} value={this.state.Remark} onChange={this.handleChange}
                  className="form-control" name="Remark" />
              </div>
            </div>
            <div className="col-md-12 text-center mt-4">
              <button type="submit" className="btn btn-primary">Submit</button>
            </div>
          </form>
        </Dialog>

        <Dialog className="popup-modal" style={{ width: '500px' }} visible={this.state.visible} modal={true} onHide={this.hideFunc}>
  <form  className="form-padding" autoComplete="off">
    <div className="row">
      <div className="col-md-3 text-right">
        <label>Batch<span>*</span>:</label>
      </div>
      <div className="col-md-9 mb-2">
        <input 
          type="text" 
          value={this.state.Batch} 
          onChange={this.handleBatchChange} 
          className="form-control" 
          name="Batch" 
          noValidate 
        />
      </div>

      <div className="col-md-12 text-center">
        
        <button type="submit" className="btn btn-primary" onClick={this.handleUpdateButtonClick}>
        {this.state.buttonLabel}
              </button>
      </div>
        {/* <div className="col-md-12 text-left">
          <label>Note: Fields marked as (<span style={{ color: 'red' }}>*</span>) are required</label>
        </div> */}
    </div>
  </form>
</Dialog>

      </>
    );
  }
}
